import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { formatAMPM } from "../../../utils/common";
import { OrderListUpdate } from "../../../API/routine";
import { toast } from "react-toastify";
import { Base_Url } from "../../../API/config";
import apiClient from "../../../utils/ApiClient";


const EventLogisticsList = ({
  logisticsDetails,
  handleLogisticsChange,
  eventId,
  fetchRoutineDetail,
  showEventType,
}) => {
  const [rows, setRows] = useState([]);
  const [activeRowId, setActiveRowId] = useState(null);
  const IsAccess = JSON.parse(localStorage.getItem("userDetail"));
  //const [visibleStudioId, setVisibleStudioId] = useState(null);
  const [studioInfo, setStudioInfo] = useState(null);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [notesModal, setNotesModal] = useState(null); 
  const [notesValue, setNotesValue] = useState("");
  const [isSaving, setIsSaving] = useState(false);

  // useEffect(() => {
  //   // const filtered = logisticsDetails?.filter((row) => row?.completed === showEventType) || [];
  //    let result = [];
  //   if (showEventType === 1) {
  //     // return all rows sorted by id ascending
  //     result = [...(logisticsDetails || [])].sort((a, b) => a.id - b.id);
  //   } else {
  //     // normal filtering
  //     result = (logisticsDetails || []).filter(
  //       (row) => row?.completed === showEventType
  //     );
  //   }
  //   setRows(result);
  //   //setRows(filtered);
  //   //setRows(logisticsDetails);
  // }, [logisticsDetails, showEventType]);

  useEffect(() => {
    const result = (logisticsDetails || []).filter(
      (row) => row?.completed === showEventType
    );

    setRows(result);
  }, [logisticsDetails, showEventType]);

  const handleDragEnd = (result) => {
    if (!result.destination) return;
    const { source, destination } = result;

    const updatedRows = [...rows];
    const [removed] = updatedRows.splice(source.index, 1);
    updatedRows.splice(destination.index, 0, removed);

    const updatedArray = updatedRows.map((row, i) => ({
      id: row.id,
      index: i,
    }));

    onChange(updatedArray, rows[source.index]?.id, rows[destination.index]?.id);
    setRows(updatedRows);
  };

  const onChange = async (data, previousID, newID) => {
    const payload = {
      event_id: eventId,
      previous_id: previousID,
      new_id: newID,
      order_list_update: data,
    };
    try {
      const response = await OrderListUpdate(payload);
      if (response?.status) {
        fetchRoutineDetail();
        toast.success(response.message || "Success!");
      } else {
        toast.error(response.message);
      }
    } catch (error) {
      console.error("Error during API request:", error);
    }
  };

  const handleAccessChange = async (userId, changes) => {
    const payload = {
      id: userId,
      completed:
        changes?.props !== undefined
          ? 0
          : changes?.completed !== ""
          ? changes?.completed === true
            ? 1
            : 0
          : 0,
    };

    if (typeof changes?.starts !== "undefined") {
      payload.starts = changes.starts;
    }
    if (changes?.props !== undefined) {
      payload.props = changes.props;
    }
    if (changes.previousId) {
      payload.previous_id = changes.previousId;
    }

    await handleLogisticsChange(payload);

    if (changes.starts === 1) {
      setActiveRowId(userId);
    }
    if (changes.starts === 2 || changes.completed === true) {
      setActiveRowId(null);
    }
  };

  const handleSaveNotes = async () => {
    try {
      // validation
      if (!notesValue || notesValue.trim() === "") {
        toast.error("Notes cannot be empty");
        return;
      }
      setIsSaving(true);
      const response = await apiClient.post(`/api/events/${notesModal.id}/notes`,{ notes: notesValue } );
      const data = response.data;
      if (data?.success !== false) {
        // update UI locally
        setRows((prev) =>
          prev.map((item) =>
            item.id === notesModal.id
              ? { ...item, notes: notesValue }
              : item
          )
        );
        toast.success(data.message || "Success!");
        setNotesModal(null);
      } else {
        toast.error(data.message || "Something went wrong");
      }
    } catch (error) {
      console.error(error);
      toast.error(
        error?.response?.data?.message || "Error updating notes"
      );
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div className="drag-table">
        <div
          className="table-responsive"
          style={{ maxHeight: "calc(100vh - 183px)", overflowY: "auto" }}
        >
          <DragDropContext onDragEnd={handleDragEnd}>
            <Droppable droppableId="droppable">
              {(provided) => (
                <table
                  className="table"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                  style={{ width: "100%" }}
                >
                  <thead className="text-center">
                    <tr>
                      <th>Time</th>
                      <th>Props</th>
                      <th>Entry #</th>
                      <th style={{ color: "#ffffff" }}>Info</th>
                      <th style={{ color: "#ffffff" }}>Notes</th>
                      <th>Entry Title</th>
                      <th>Age</th>
                      <th>Level</th>
                      <th>Entry Division</th>
                      <th>Performers</th>
                      <th>Category</th>
                      <th>Starts</th>
                      <th>Completed</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, index) => {
                      // if (row?.completed !== showEventType) return null;

                      return (
                        <Draggable
                          key={row.id}
                          draggableId={row.id.toString()}
                          index={index}
                          isDragDisabled={row.completed === 1}
                        >
                          {(provided, snapshot) => (
                            <tr
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                              className={`text-center ${
                                row?.starts === 1 ||
                                row?.starts === 2 ||
                                row?.completed === 1
                                  ? "start"
                                  : "notstart"
                              }`}
                              style={{
                                cursor:
                                  row.completed === 1 ? "not-allowed" : "",
                                ...provided.draggableProps.style,
                                // position: snapshot.isDragging ? "absolute" : "static",
                                zIndex: snapshot.isDragging ? 999 : "auto",
                                width: "100%",
                                // left: snapshot.isDragging ? "0" : "auto",
                                transition: "all 0.1s ease-out",
                              }}
                            >
                              <td>{formatAMPM(row?.event_time_from)}</td>
                              <td className="text-center">
                                {row?.type === "routine" || (row?.entry && row.entry.trim() !== "") &&
                                IsAccess?.is_access ? (
                                  <label className="container">
                                    <input
                                      type="checkbox"
                                      checked={row?.props === 1}
                                      disabled={row?.completed === 1}
                                      onChange={(e) => {
                                        const newValue = e.target.checked
                                          ? 1
                                          : 0;
                                        handleAccessChange(row.id, {
                                          props: newValue,
                                          starts: row.starts ?? 0,
                                        });
                                      }}
                                    />
                                    <span className="checkmark"></span>
                                  </label>
                                ) : (
                                  "-"
                                )}
                              </td>
                              <td>{row?.entry || "-"}</td>
                              <td className="text-center">
                                {(row?.entry && row.entry.trim() !== "") && (
                                  <div
                                    style={{ position: "relative", display: "inline-block" }}
                                    onMouseEnter={() => setHoveredRow(index)} 
                                    onMouseLeave={() => setHoveredRow(null)}
                                  >
                                    <i className="fa fa-eye" style={{ cursor: "pointer" }}></i>

                                    {hoveredRow === index && (
                                      <div
                                        style={{
                                          position: "absolute",
                                          top: "0",
                                          right: "-15px",
                                          transform: "translateX(100%)",
                                          background: "#fff",
                                          padding: "8px 12px",
                                          borderRadius: "6px",
                                          boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
                                          zIndex: 9999,
                                          minWidth: "180px",
                                          whiteSpace: "nowrap",
                                          textAlign: "left"
                                        }}
                                      >
                                        <strong>Studio Information</strong>
                                        <div>Studio Name: {row?.studio_name || "-"}</div>
                                        <div>Studio Code: {row?.studio_code || "-"}</div>
                                      </div>
                                     )}
                                  </div>
                                )}
                              </td>
                              {/* <td className="text-center">
                                {!["awards", "openDoor", "break"].includes(row?.type) && (
                                  <i
                                    className={row?.notes ? "fa fa-pencil text-warning" : "fa fa-pencil"}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setNotesModal({ id: row.id });
                                      setNotesValue(row?.notes || "");
                                    }}
                                  ></i>
                                )}
                              </td> */}
                              <td className="text-center">
                                {(row?.entry && row.entry.trim() !== "") &&
                                  row?.notes && row.notes.trim() !== "" && (
                                    <i
                                      className="fa fa-pencil text-warning"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => {
                                        setNotesModal({ id: row.id });
                                        setNotesValue(row?.notes || "");
                                      }}
                                    ></i>
                                )}
                              </td>
                              <td>{row?.entry_title || "-"}</td>
                              <td>{row?.masterAgeClass?.name || "-"}</td>
                              <td>{row?.masterLevel?.name || "-"}</td>
                              <td>{row?.masterEntryDivision?.name || "-"}</td>
                              <td>{row?.performers || "-"}</td>
                              <td>{row?.masterMusicCategory?.name || "-"}</td>
                              <td className="text-center">
                                {row?.type === "routine" || (row?.entry && row.entry.trim() !== "") &&
                                IsAccess?.is_access ? (
                                  <div className="checkbox-wrapper">
                                    <label
                                      htmlFor={`on-${row.id}`}
                                      className="checkbox-label check_box_btn"
                                    >
                                      <input
                                        type="checkbox"
                                        id={`on-${row.id}`}
                                        checked={row.starts === 1}
                                        disabled={row.completed === 1}
                                        onChange={async () => {
                                          if (row.starts === 1) {
                                            await handleAccessChange(row.id, {
                                              starts: 0,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          } else {
                                            await handleAccessChange(row.id, {
                                              starts: 1,
                                              completed: false,
                                              previousId: activeRowId,
                                            });
                                            setActiveRowId(row.id);
                                          }
                                        }}
                                      />
                                      <p className="simple">On</p>
                                    </label>
                                    <label
                                      htmlFor={`off-${row.id}`}
                                      className="checkbox-label check_box_btn"
                                    >
                                      <input
                                        type="checkbox"
                                        id={`off-${row.id}`}
                                        checked={row.starts === 2}
                                        disabled={row.completed === 1}
                                        onChange={async () => {
                                          if (row.starts === 2) {
                                            await handleAccessChange(row.id, {
                                              starts: 0,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          } else {
                                            await handleAccessChange(row.id, {
                                              starts: 2,
                                              completed: false,
                                            });
                                            setActiveRowId(null);
                                          }
                                        }}
                                      />
                                      <p>Off</p>
                                    </label>
                                  </div>
                                ) : (
                                  "-"
                                )}
                              </td>
                              {/* <td className="text-center">
                                {IsAccess?.is_access ? (
                                  <input
                                    type="checkbox"
                                    className="complete"
                                    onChange={(e) =>
                                      row.completed === 0
                                        ? handleAccessChange(row.id, {
                                            completed: e.target.checked,
                                            starts: row.starts ?? 0,
                                          })
                                        : null
                                    }
                                    checked={row.completed === 1}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td> */}
                              <td className="text-center">
                                {IsAccess?.is_access ? (
                                  <input
                                    type="checkbox"
                                    className="complete"
                                    onChange={(e) =>
                                      handleAccessChange(row.id, {
                                        completed: e.target.checked,
                                        starts: row.starts ?? 0,
                                      })
                                    }
                                    checked={row.completed === 1}
                                  />
                                ) : (
                                  "-"
                                )}
                              </td>
                            </tr>
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </tbody>
                </table>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      {notesModal && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              
              {/* Header */}
              <div className="modal-header">
                <h5 className="modal-title">Notes</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setNotesModal(null)}
                ></button>
              </div>

              {/* Body */}
              <div className="modal-body">
                <textarea
                  className="form-control"
                  rows={4}
                  value={notesValue}
                  onChange={(e) => setNotesValue(e.target.value)}
                  placeholder="Enter notes..."
                />
              </div>

              {/* Footer */}
              <div className="modal-footer">
                <button
                  className="btn btn-secondary"
                  onClick={() => setNotesModal(null)}
                >
                  Cancel
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleSaveNotes}
                  disabled={isSaving}
                >
                {isSaving ? "Submitting..." : "Save"}
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
      {/* {studioInfo && (
        <div
          style={{
            position: "fixed",
            top: "20%",
            right: "20%",
            background: "#fff",
            padding: "12px 16px",
            borderRadius: "6px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            zIndex: 9999,
            minWidth: "220px"
          }}
        >
          <strong>Studio Information</strong>
          <div>Studio Name: {studioInfo?.name || "-"}</div>
          <div>Studio Code: {studioInfo?.code || "-"}</div>
        </div>
      )} */}
      {/* {studioInfo && (
        <div
          className="modal fade show"
          style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}
        >
          <div className="modal-dialog modal-md modal-dialog-centered">
            <div className="modal-content">
              
              <div className="modal-header">
                <h5 className="modal-title">Studio Information</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setStudioInfo(null)}
                ></button>
              </div>

              <div className="modal-body">
                <p>
                  <strong>Studio Name :</strong> {studioInfo?.name || "-"}
                </p>

                <p>
                  <strong>Studio Code :</strong> {studioInfo?.code || "-"}
                </p>
              </div>

            </div>
          </div>
        </div>
      )} */}
      {/* {studioInfo && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0,0,0,0.4)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999
          }}
        >
          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "8px",
              minWidth: "300px",
              textAlign: "left",
              boxShadow: "0 4px 10px rgba(0,0,0,0.2)"
            }}
          >
            <h3 style={{ marginBottom: "15px" }}>Studio Information</h3>

            <p>
              <strong>Studio Name :</strong> {studioInfo.name || "-"}
            </p>

            <p>
              <strong>Studio Code :</strong> {studioInfo.code || "-"}
            </p>

            <button
              onClick={() => setStudioInfo(null)}
              style={{
                marginTop: "10px",
                padding: "6px 12px",
                border: "none",
                background: "#007bff",
                color: "#fff",
                borderRadius: "4px",
                cursor: "pointer"
              }}
            >
              Close
            </button>
          </div>
        </div>
      )} */}
    </div>
  );
};

export default EventLogisticsList;
